// Update Lookbook Order Fulfillment
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_REQUEST';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_DONE = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_DONE';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_FAILED = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_FAILED';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_CLEAR_ERRORS = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_CLEAR_ERRORS';
export const UPDATE_LOOKBOOK_ORDER_FULFILLMENT_RESET = 'UPDATE_LOOKBOOK_ORDER_FULFILLMENT_RESET';
